import * as React from 'react';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { Link } from 'react-router';
import { __ } from 'react-i18n/lib';
import {
  FlexRowCenterVertical,
  FlexColCenter,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { prop, getSymbolFromCurrency } from '../../../utilities';
import { ProductSearchItem } from '../Product/ProductSearchItem';
import { ZemplinLoaderWrapper } from '../../..';
import {
  getSearchProductInfo,
  getSearchCategoryInfo,
} from '../../../utilities/selectors';
import { NoItemsWrapper } from '../General/NoItemsWrapper';
import { Loader } from '../General/Loader';

// Interfaces

/*****************/

// Styled Components

const SearchDropdown = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  background: ${({ theme }) => theme.color.white};
  color: ${({ theme }) => theme.color.text};
  border-radius: 0 0 ${rem(2)} ${rem(2)};
  width: ${rem(320)};
  max-height: ${rem(480)};
  overflow-y: auto;
  position: absolute;
  z-index: 500;
  left: unset;
  position: absolute;
  top: 100%;
  right: 0;
  transform: translateY(${rem(5)});
  box-shadow: ${({ theme }) => theme.boxShadow.secondary};
  padding: 0;
`;

const NoResultsSearchDropdown = styled(SearchDropdown)`
  padding: ${rem(24)};
`;

const DropdownSection = styled.div`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(14)};
`;

const ProductDropdownSection = styled(DropdownSection)`
  padding-top: ${rem(24)};
  padding-bottom: ${rem(8)};
`;

const DropdownTitle = styled.p`
  color: ${({ theme }) => theme.colors.placeholder};
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(12)};
  margin: 0;
  padding-bottom: ${rem(16)};
`;

const DropdownShowAllProducts = styled(Link)`
  display: block;
  background: transparent;
  border-radius: 0 0 0 ${rem(2)};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 14px;
  line-height: 1;
  text-align: center;
  padding: ${rem(19)} ${rem(10)};
  margin-top: ${rem(11)};

  ${({ theme }) => theme.media(0, 1024)} {
    padding: ${rem(14)} ${rem(10)};
  }

  &:hover {
    cursor: pointer;
    color: white;
    background: ${({ theme }) => theme.colors.primary};
  }
`;

const DropdownName = styled(TextP)`
  font-size: ${rem(14)};
`;

const DropdownItem = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-top: ${rem(14)};

  &:hover > ${DropdownName} {
    text-decoration: underline;
  }
`;

const NumberOfProducts = styled(TextP)`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.placeholder};
`;

const HighlightedText = styled.span`
  background-color: ${({ theme }) => theme.colors.highlight};
`;

const Bold = styled.span`
  font-weight: 400;
  font-size: ${rem(18)};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const ProductTitleWrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  border-bottom: ${rem(1)} solid rgb(49, 39, 131, 0.08);
`;

const NoResults = styled(TextP)`
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-top: ${rem(14)};
  word-break: break-word;
`;

const ProductResultsWrapper = styled(FlexColCenter)`
  padding-top: ${rem(24)};
`;

/*****************/

class SearchResultsViewer extends React.Component {
  public render() {
    if (true) {
      return (
        <NoResultsSearchDropdown visible={true}>
          <DropdownSection>
            {__('Váš nákupný košík je prázdny')}
          </DropdownSection>
        </NoResultsSearchDropdown>
      );
    }
  }
}

export default SearchResultsViewer;
